import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface CustomModalProps {
  title: string | undefined;
  content?: React.ReactNode;
  onSubmit?: () => void;
  onSubmitCustomDisplay?: string;
  onCancel?: () => void;
  modalSize?: string;
}

export interface ModalHandle {
  show: () => void;
  hide: () => void;
}

const CustomSalesReturnModal = React.forwardRef<ModalHandle, CustomModalProps>(
  ({ title, content, onSubmit, onCancel, onSubmitCustomDisplay }, ref) => {
    const [show, setShow] = React.useState(false);

    React.useImperativeHandle(ref, () => ({
      show: () => setShow(true),
      hide: () => setShow(false)
    }));

    const handleClose = () => setShow(false);

    return (
      <>
        <Modal show={show} onHide={handleClose} size="lg" centered>
          <Modal.Dialog className="m-0">
            <Modal.Header closeButton>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{content}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={onCancel || handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onSubmit || handleClose}>
                {onSubmitCustomDisplay ? onSubmitCustomDisplay : 'Submit'}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal>
      </>
    );
  }
);

export default CustomSalesReturnModal;
